import { BaseComponent2 } from '../../_common/client/base-component2';
import { trackMoveAction, trackView } from '../../_common/client/tracking';
import { trackNavigationEvent } from './track-navigation-event';

const showMoreLinkSelector = '.js_cr_sidebar__variation-show-more-link';
const headlineLinkSelector = '.js_cr_sidebar__headline-link';
const variationImageLinkSelector = '.js_cr_sidebar__variation-image-link';
const backToArticleButtonSelector = '.js_cr_sidebar__back-to-article-button';
const showAllLinkSelector = '.js_cr_sidebar__show-all-link';

export class CustomerReviewSidebarComponent extends BaseComponent2 {
    public rootSelector = '.js_cr_sidebar';

    public async init(): Promise<void> {
        if (!this.isPresent()) return;

        trackMoreVariationsOnPageImpression(this.getRootElement());
        addTrackingToPageLink(this.getRootElement());
        trackNavigationOnClick(this.getRootElement(), headlineLinkSelector, 'headline');
        trackNavigationOnClick(this.getRootElement(), showMoreLinkSelector, 'variation');
        trackNavigationOnClick(this.getRootElement(), variationImageLinkSelector, 'image');
        trackNavigationOnClick(this.getRootElement(), backToArticleButtonSelector, 'button');
    }
}

const addTrackingToPageLink = (rootElement: HTMLElement) => {
    const linkElement = rootElement.querySelector(showAllLinkSelector);
    if (linkElement) {
        linkElement.addEventListener('click', () => {
            trackMoveAction({ ot_PageCluster: ['Artikeldetailseite'], review_Navigation: ['center'] }, { name: 'click', features: [] });
        });
    }
};

const trackMoreVariationsOnPageImpression = (rootElement: HTMLElement) => {
    const showMoreLink = rootElement.querySelector(showMoreLinkSelector);
    if (!showMoreLink) return;
    trackView({ product_MoreVariations: ['true'] });
};

const trackNavigationOnClick = (
    rootElement: HTMLElement,
    selector: string,
    trackingLabelValue: 'headline' | 'variation' | 'image' | 'button'
) => {
    const elementToTrack = rootElement.querySelector(selector);
    if (!elementToTrack) return;
    elementToTrack.addEventListener('click', () => {
        trackNavigationEvent(trackingLabelValue);
    });
};
